<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        請求書情報ダウンロード
      </template>
      <template v-slot:content>
        <v-col cols="5" class="pt-0 mb-4">
          <p class="bold mx-0 mb-0">出力条件：25日AM2:00時点のデータ</p>
          <p class="bold mx-0 mb-0">有効な顧客のみ出力</p>
          <p class="bold mx-0 mb-0">ソート条件：お客様No.昇順、電話番号昇順</p>
        </v-col>
        <h5 class="ml-3">
          ≪月次選択 ダウンロード≫ (25日 AM2:00)
        </h5>
        <p class="ml-3 mb-0" v-if="months.length === 0">月次の請求CSVが存在しません。</p>
        <v-col class="d-flex" cols="4" sm="6" md="5">
          <v-select
            :items="months"
            v-model="selectedMonth"
            :disabled="months.length === 0"
            label="月次"
            class="mr-4"
            color="secondary"
          />
          <v-btn class="mt-5" :disabled="months.length === 0" small color="secondary" @click="downloadPerMonth">ダウンロード</v-btn>
        </v-col>


        <h5 class="ml-3 mt-7">
          ≪日次選択 ダウンロード≫ (AM2:00)
        </h5>
        <v-col class="d-flex" cols="4" sm="6" md="5">
          <v-select
            :items="dates"
            v-model="selectedDate"
            label="日次"
            class="mr-4"
            color="secondary"
          />
          <v-btn class="mt-5" small color="secondary" @click="downloadPerDate">ダウンロード</v-btn>
        </v-col>
      </template>
    </v-base-card>
  </div>
</template>
<script>

import VBaseCard from "@/components/molecules/BaseCard";
import moment from 'moment'
import { saveAs } from 'file-saver'



export default {
  components: {
    VBaseCard,
  },
  data() {
    return {
      months: [],
      dates: [],
      selectedMonth: null,
      selectedDate: moment(new Date).format('YYYY/MM/DD'),
    };
  },

  mounted() {
    // リリース日 ~ 今日まで
    const releaseDate = new Date(process.env.VUE_APP_RELEASE_DATE)
    const startDate = releaseDate
    const endDate = new Date
    for(var d = startDate; d < endDate; d.setDate(d.getDate()+1)) {
      this.dates.push(moment(d).format('YYYY/MM/DD'))
      if (d.getDate() === 25) {
        this.selectedMonth = moment(d).format('YYYY/MM/DD')
        this.months.push(this.selectedMonth)
      }
    }
    this.months = this.months.reverse()
    this.dates = this.dates.reverse()
  },

  methods: {
    async downloadPerMonth(){
      if (!this.selectedMonth) {
        this.$toasted.global.error({ message: '年/月を選択して下さい' })
        return
      }
      const ymd = this.selectedMonth.split('/')
      await this.$axios("/api/v1/admin/customers/download_billing_csv", {
        params: { year: ymd[0], month: Number(ymd[1]) },
        responseType: 'blob'
      }).then(res => {
        this.downloadFile(res.data, res.data.type, res.headers)
      }).catch(error => {
        if (error.response.status == 404) {
          this.$toasted.global.error({ message: '請求CSVが存在しません' })
        } else{
          this.$toasted.global.error({ message: '予期せぬエラーが発生しました' })
        }
      })
    },

    async downloadPerDate(){
      if (!this.selectedDate) {
        this.$toasted.global.error({ message: '年/月/日を選択して下さい' })
        return
      }
      await this.$axios("/api/v1/admin/customers/download_billing_csv", {
        params: { date: this.selectedDate },
        responseType: 'blob'
      }).then(res => {
        this.downloadFile(res.data, res.data.type, res.headers)
      }).catch(error => {
        if (error.response.status == 404) {
          this.$toasted.global.error({ message: '請求CSVが存在しません' })
        } else{
          this.$toasted.global.error({ message: '予期せぬエラーが発生しました' })
        }
      })
    },

    downloadFile(data, type, headers) {
      const blob = new Blob([data], { type: type })

      //レスポンスヘッダからファイル名を取得
      const contentDisposition = headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)

      saveAs(blob, fileName)
    },

    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')

      return fileName
    },
  },
}
</script>

<style lang="stylus" scoped>
h5
  color #0079e8

p
  font-size 13px
</style>
